'use client';

import { usePathname, useRouter } from 'next/navigation';
import { PropsWithChildren } from 'react';
import React from 'react';

import { MenuClientHideConditions, ServerMenu } from '../helpers';
import { AnalyticsEventName } from '@/api/analytics';
import { isExternalURL } from '@/helpers/common';
import { useAnalytics } from '@/hooks/analytics';

export type MenuLinkClientWrapperProps = {
  id: ServerMenu;
  url: string;
  hideConditions?: MenuClientHideConditions[];
  hideConditionResults: Record<string, boolean>;
  onClick?: () => void;
};

export const MenuLinkClientWrapper = React.forwardRef<
  HTMLLIElement,
  PropsWithChildren<MenuLinkClientWrapperProps>
>(
  (
    { id, url, children, hideConditions, hideConditionResults, onClick },
    ref
  ) => {
    const { sendEventToAnalytics } = useAnalytics();
    const { push } = useRouter();
    const pathname = usePathname();

    const checkHideConditions = () => {
      return hideConditions?.some(
        (condition) => hideConditionResults[condition]
      );
    };
    const isHidden = checkHideConditions();

    const isActive =
      url === pathname || (url === '/' && pathname.slice(0, 5) === '/game');

    const handleClickMenuItem =
      (id: ServerMenu, url: string) => async (event: React.MouseEvent) => {
        event.preventDefault();
        id === ServerMenu.Sports &&
          (await sendEventToAnalytics({
            name: AnalyticsEventName.HEADER__BUTTONS__NAVIGATION_LINK__CLICK,
            attributes: {
              additionalData: JSON.stringify({ name: id }),
            },
          }));
        onClick && onClick();
        isExternalURL(url) ? window.location.replace(url) : push(url);
      };

    if (isHidden) return null;

    return (
      <li
        ref={ref}
        onClick={handleClickMenuItem(id, url)}
        className={isActive ? 'active' : ''}
      >
        {children}
      </li>
    );
  }
);
